<template>
  <div class="all-box">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>充值功能开关</span>
      </div>
      <div v-for="group in switchGroups" :key="group.title" class="group">
        <div class="group-title">{{ group.title }}</div>
        <div
          class="switch-row"
          v-for="item in group.items"
          :key="item.key"
        >
          <span class="label">{{ item.label }}</span>
          <el-switch
            v-model="form[item.key]"
            :active-value="1"
            :inactive-value="0"
            active-text="开启"
            inactive-text="关闭"
            @change="val => setIsPay(item.key, val)"
          ></el-switch>
        </div>
      </div>
      <div class="min-text">
        提示：当前系统下虚拟或普通任一开启时，小程序「我的」页显示充值按钮；支付时优先普通支付。
      </div>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>虚拟支付配置</span>
      </div>
      <el-form label-width="120px" size="small">
        <el-form-item label="offerId">
          <el-input
            v-model="virtualConfig.virtual_pay_offer_id"
            placeholder="小程序虚拟支付基础配置 offerId"
          />
        </el-form-item>
        <el-form-item label="现网 AppKey">
          <el-input
            v-model="virtualConfig.virtual_pay_app_key"
            placeholder="虚拟支付 → 基础配置 → 现网 AppKey"
            show-password
          />
        </el-form-item>
        <el-form-item label="沙箱 AppKey">
          <el-input
            v-model="virtualConfig.virtual_pay_app_key_sandbox"
            placeholder="虚拟支付 → 基础配置 → 沙箱 AppKey"
            show-password
          />
        </el-form-item>
        <el-form-item label="默认环境">
          <el-radio-group v-model="virtualConfig.virtual_pay_env">
            <el-radio :label="0">现网</el-radio>
            <el-radio :label="1">沙箱</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="savingConfig" @click="saveVirtualConfig"
            >保存配置</el-button
          >
        </el-form-item>
      </el-form>
      <div class="min-text">
        安卓/鸿蒙按「默认环境」走沙箱或现网；苹果虚拟支付不支持沙箱，始终走现网（会产生真实扣款）。请分别填写现网/沙箱
        AppKey，并与环境对应。
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  getIsPay,
  setIsPay,
  setVirtualPayConfig
} from "@/request/api/setting";

export default {
  data() {
    return {
      form: {
        is_pay_android_normal: 0,
        is_pay_android_virtual: 0,
        is_pay_ios_normal: 0,
        is_pay_ios_virtual: 0,
        is_pay_harmony_normal: 0,
        is_pay_harmony_virtual: 0
      },
      virtualConfig: {
        virtual_pay_offer_id: "",
        virtual_pay_app_key: "",
        virtual_pay_app_key_sandbox: "",
        virtual_pay_env: 0
      },
      savingConfig: false,
      switchGroups: [
        {
          title: "安卓",
          items: [
            { key: "is_pay_android_normal", label: "普通支付" },
            { key: "is_pay_android_virtual", label: "虚拟支付" }
          ]
        },
        {
          title: "苹果",
          items: [
            { key: "is_pay_ios_normal", label: "普通支付" },
            { key: "is_pay_ios_virtual", label: "虚拟支付" }
          ]
        },
        {
          title: "鸿蒙",
          items: [
            { key: "is_pay_harmony_normal", label: "普通支付" },
            { key: "is_pay_harmony_virtual", label: "虚拟支付" }
          ]
        }
      ]
    };
  },
  created() {
    this.getIsPay();
  },
  methods: {
    getIsPay() {
      getIsPay().then(res => {
        Object.keys(this.form).forEach(key => {
          this.form[key] = Number(res[key]) === 1 ? 1 : 0;
        });
        this.virtualConfig.virtual_pay_offer_id =
          res.virtual_pay_offer_id || "";
        this.virtualConfig.virtual_pay_app_key =
          res.virtual_pay_app_key || "";
        this.virtualConfig.virtual_pay_app_key_sandbox =
          res.virtual_pay_app_key_sandbox || "";
        this.virtualConfig.virtual_pay_env =
          Number(res.virtual_pay_env) === 1 ? 1 : 0;
      });
    },
    setIsPay(key, val) {
      const labelMap = {
        is_pay_android_normal: "安卓普通支付",
        is_pay_android_virtual: "安卓虚拟支付",
        is_pay_ios_normal: "苹果普通支付",
        is_pay_ios_virtual: "苹果虚拟支付",
        is_pay_harmony_normal: "鸿蒙普通支付",
        is_pay_harmony_virtual: "鸿蒙虚拟支付"
      };
      setIsPay({ [key]: val })
        .then(() => {
          this.$message({
            message:
              val === 1
                ? `已开启${labelMap[key]}`
                : `已关闭${labelMap[key]}`,
            type: "success"
          });
        })
        .catch(() => {
          this.form[key] = val === 1 ? 0 : 1;
        });
    },
    saveVirtualConfig() {
      this.savingConfig = true;
      setVirtualPayConfig({ ...this.virtualConfig })
        .then(res => {
          if (res) {
            this.virtualConfig.virtual_pay_offer_id =
              res.virtual_pay_offer_id || "";
            this.virtualConfig.virtual_pay_app_key =
              res.virtual_pay_app_key || "";
            this.virtualConfig.virtual_pay_app_key_sandbox =
              res.virtual_pay_app_key_sandbox || "";
            this.virtualConfig.virtual_pay_env =
              Number(res.virtual_pay_env) === 1 ? 1 : 0;
          }
          this.$message.success("虚拟支付配置已保存");
        })
        .finally(() => {
          this.savingConfig = false;
        });
    }
  }
};
</script>

<style scoped>
.all-box {
  display: flex;
  flex-wrap: wrap;
}
.box-card {
  width: 42%;
  min-width: 360px;
  margin-right: 40px;
  box-shadow: none;
  margin-top: 20px;
}
.group {
  margin-bottom: 18px;
}
.group-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
}
.switch-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding-left: 8px;
}
.label {
  font-size: 14px;
  color: #303133;
}
.min-text {
  font-size: 13px;
  margin: 10px 0 0;
  color: #909399;
  line-height: 1.5;
}
</style>
